import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [theme, setTheme] = useState('light');
  const location = useLocation();

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
    document.documentElement?.classList?.toggle('dark', savedTheme === 'dark');
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement?.classList?.toggle('dark', newTheme === 'dark');
  };

  const navigationItems = [
    { label: 'Home', path: '/home' },
    { label: 'Cultaz Offline App', path: '/desktop-app' },
    { label: 'Features', path: '/features' },
    { label: 'Pricing', path: '/pricing' },
    { label: 'Support', path: '/support' }
  ];

  const isActivePath = (path) => location?.pathname === path;

  return (
    <header className="sticky top-0 z-40 w-full bg-card shadow-purple transition-smooth">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex h-20 items-center justify-between">
          <Link to="/home" className="flex items-center space-x-3 transition-smooth hover:opacity-90">
            <img src="/logo-light.png" alt="Cultaz" className="h-8 w-auto dark:hidden" />
            <img src="/logo-dark.png" alt="Cultaz" className="h-8 w-auto hidden dark:block" />
          </Link>

          <nav className="hidden lg:flex items-center space-x-2">
            {navigationItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative px-4 py-2 font-body text-base font-medium transition-smooth hover:text-primary ${isActivePath(item.path) ? 'text-primary' : 'text-foreground'}`}
              >
                {item.label}
                {isActivePath(item.path) && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" />}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            <button
              onClick={toggleTheme}
              className="flex h-10 w-10 items-center justify-center rounded-lg border border-border bg-card transition-smooth hover:bg-muted hover:scale-105 focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
              aria-label="Toggle theme"
            >
              <Icon name={theme === 'light' ? 'Moon' : 'Sun'} size={20} color="var(--color-foreground)" strokeWidth={2} />
            </button>

            <a href="https://app.cultaz.com" target="_blank" rel="noopener noreferrer" className="font-body text-base font-medium text-foreground transition-smooth hover:text-primary">Sign In</a>

            <a href="https://app.cultaz.com" target="_blank" rel="noopener noreferrer">
              <Button variant="default" size="default">Get Started</Button>
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden flex h-12 w-12 items-center justify-center rounded-lg border border-border bg-card transition-smooth hover:bg-muted focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
            aria-label="Toggle mobile menu"
          >
            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} color="var(--color-foreground)" strokeWidth={2} />
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 top-20 z-50 bg-card">
          <nav className="flex flex-col space-y-1 p-6">
            {navigationItems.map((item) => (
              <Link key={item.path} to={item.path} onClick={() => setIsMobileMenuOpen(false)} className={`px-4 py-3 font-body text-lg font-medium transition-smooth hover:bg-muted rounded-lg ${isActivePath(item.path) ? 'text-primary bg-muted' : 'text-foreground'}`}>
                {item.label}
              </Link>
            ))}

            <div className="pt-6 border-t border-border mt-6">
              <button onClick={() => { toggleTheme(); setIsMobileMenuOpen(false); }} className="flex w-full items-center justify-between px-4 py-3 font-body text-lg font-medium text-foreground transition-smooth hover:bg-muted rounded-lg">
                <span>Theme</span>
                <Icon name={theme === 'light' ? 'Moon' : 'Sun'} size={20} color="var(--color-foreground)" strokeWidth={2} />
              </button>

              <a href="https://app.cultaz.com" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)} className="block px-4 py-3 mt-2 font-body text-lg font-medium text-foreground transition-smooth hover:bg-muted rounded-lg">Sign In</a>

              <a href="https://app.cultaz.com" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)} className="block mt-4">
                <Button variant="default" size="default" fullWidth>Get Started</Button>
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;